const defaultSettings = {
    PASSWORD_STRENGTH_SCORE: "1",
    EXPIRE_OFFSET_SECONDS: 1200, // 20 minutes
};

export default defaultSettings;
